<div class="fix-width m-margin bg-white flex column radius margin-top-largest shadow">
	<img src="assets/test.jpg" />

	<div class="padding">
		<div class="flex center margin-bottom">
			<img src="https://basicplatformblob.blob.core.windows.net/resources/LOGOS/BASICNET.PNG" />
		</div>
		<div>
			Welcome to
			<b>BasicStudios</b>
			! Please select an option:
		</div>

		<div class="flex column center margin-top bg-primary-dark margin-bottom padding radius white hover" (click)="goToLogin()">
			<i class="fa-solid fa-arrow-right-to-bracket fa-2xl margin-bottom margin-top"></i>
			Login with BasicNet
		</div>

		<div class="flex column center bg-primary-dark padding radius white hover disabled" (click)="requestCredentials()">
			<i class="fa-solid fa-lock-open fa-2xl margin-bottom margin-top"></i>
			Request credentials
		</div>
	</div>
</div>
